import { PremiumStatus } from 'multirpc-sdk';
import { createSelector } from 'reselect';

import { selectIsLoggedIn } from 'modules/auth/store/selectors';

import {
  selectAccountStatusDataWithFallback,
  selectAccountStatusData,
  selectAccountStatusState,
} from '../actions/fetchAccountStatus';

const selectAccountStatus = createSelector(
  selectAccountStatusDataWithFallback,
  ({ status }) => status,
);

export const selectAccountStatusError = createSelector(
  selectAccountStatusState,
  ({ error }) => error,
);

export const selectAccountStatusLoaded = createSelector(
  selectAccountStatusState,
  ({ data }) => typeof data !== 'undefined',
);

export const selectIsFreemium = createSelector(
  selectAccountStatusData,
  selectIsLoggedIn,
  (data, isLoggedIn) => isLoggedIn && !!data?.isFreemium,
);

export const selectIsPremium = createSelector(
  selectAccountStatusDataWithFallback,
  selectIsLoggedIn,
  ({ isFreemium }, isLoggedIn) => isLoggedIn && !isFreemium,
);

export const selectIsEnterprise = createSelector(
  selectAccountStatusDataWithFallback,
  ({ isEnterprise }) => isEnterprise,
);

export const selectIsInactive = createSelector(
  selectAccountStatus,
  status => status === PremiumStatus.INACTIVE,
);
